import fitty from 'fitty';
//import Swiper from 'swiper';
//import PerfectScrollbar from 'perfect-scrollbar';

export default {
  init() {
    
    var timers = [], 
        timeoutDuration = parseInt($('#app').data('timeout-duration')),
        scrollViews = []; // eslint-disable-line

    if(!timeoutDuration) {
      timeoutDuration = 15000;
    }

    $('.popup-wrapper').on('initPopupWrapper', function(){
      var el          = $(this), 
          closeEl     = $('.popup__close', el),
          hotspotEl   = $('.hotspot', el);
      
      $(hotspotEl).click(function(e){
        e.preventDefault();
        e.stopPropagation();
        
        if($(el).hasClass('open')) {
          $(el).trigger('closePopup');
        } else {
          $(el).trigger('openPopup');
        }
        
      });
      
      $(closeEl).click(function(e){
        e.preventDefault();
        e.stopPropagation();
        $(el).trigger('closePopup');
      });
      
      $(el).trigger('initPopup');

    }).on('clearTimer', function(){

      var el = $(this);
      
      if (typeof timers[$(el).index()] != 'undefined') {
        //clearInterval(timers[$(el).index()]);
        clearInterval(timers[$(el).index()].timer);
      }

    }).on('resetTimer', function(e, duration, force){ // eslint-disable-line

      var el = $(this);
      
      if (typeof duration === 'undefined') {
        duration = timeoutDuration; //3000; //15000;
      }
      
      if (typeof force === 'undefined') {
        force = true;
      }
      
      if (typeof timers[$(el).index()] != 'undefined') {
        
        if(!force && (timers[$(el).index()].duration > duration)) {
          return;
        }
        
      }
      
      
      $(el).trigger('clearTimer');
      
/*
      timers[$(el).index()] = setInterval(function(){
        console.log('timer for '+$(el).attr('id'));
        $(el).trigger('closePopup');
      }, duration);
*/


      
      timers[$(el).index()] = {
        'timer': setInterval(function(){
          $(el).trigger('closePopup');
        }, duration),
        'duration': duration,
      }
      
/*
      setInterval(function(){
        $(el).trigger('closePopup');
      }, duration);
*/


    }).on('initPopup', function(){
      
      var el = $(this), 
          contentEl     = $('.popup .popup__content', el);

      if($(contentEl).length) {
        $(contentEl).scroll(function() {
          $(el).trigger('resetTimer');
        });
      }
      
      $('.tool', el).click(function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        var tabId = $(this).data('tab');
        
        if($(this).hasClass('open')) {
          $(el).trigger('hideTab', tabId);
        } else {
          $(el).trigger('showTab', tabId);
        }
        
        setTimeout(function() {
          $('.popup-section--video', el).trigger('stopVideo');
        }, 300);
        
      });
      
      $(el).trigger('layoutSubviews');

    }).on('resetIntro', function(e){
      
      var el            = $(this), 
          popupEl       = $('.popup', el),
          introEl       = $('.popup__intro', popupEl);
      
      $(introEl).removeClass('is-closing').removeClass('is-opening').removeClass('closed').attr('style', '');
      
    }).on('showIntro', function(e){
      
      var el            = $(this), 
          popupEl       = $('.popup', el),
          introEl       = $('.popup__intro', popupEl),
          currentHeight = $(introEl).height(),
          openHeight    = $('.popup__intro__inner', introEl).height();
      
      if($(introEl).hasClass('is-opening') || !$(introEl).hasClass('closed')) {
        return;
      }
      
      $(introEl).css('height', currentHeight).removeClass('closed').removeClass('is-closing').addClass('is-opening');
      $(introEl).clearQueue().animate({height: openHeight }, 250, function() {
        $(introEl).removeClass('is-opening').attr('style', '');
      });
      
    }).on('hideIntro', function(e){
      
      var el          = $(this), 
          popupEl     = $('.popup', el),
          introEl     = $('.popup__intro', popupEl),
          openHeight  = $(introEl).height();
      
      if($(introEl).hasClass('is-closing')) {
        return;
      }
      
      $(introEl).css('height', openHeight).addClass('is-closing');
      $(introEl).clearQueue().animate({height: 0 }, 250, function() {
        $(introEl).addClass('closed').removeClass('is-closing').attr('style', '');
      });

    }).on('showTab', function(e, tabId){
      
      var el = $(this),
          bodyEl = $('.popup-wrapper__body', el),
          selectedTab = $('.popup-section--'+tabId, el), 
          selectedButton = $('[data-tab="'+tabId+'"]', el),
          adjustContent = $(selectedTab).data('adjust-height-on-open'),
          seledtedTabHeight = $(selectedTab).height(), 
          headerHeight  = $('.popup__header', el).height();
          
          $(selectedTab).addClass('open');
          $('.popup-section', el).not(selectedTab).removeClass('open');
          
          $(selectedButton).addClass('open');
          $('.tool', el).not(selectedButton).removeClass('open');
          
          $(el).trigger('resetTimer').trigger('hideIntro');
          
          if(adjustContent) {
            $(bodyEl).css('transform', 'translateY(-' + (seledtedTabHeight - headerHeight) + 'px)');
          } else {
            $(bodyEl).attr('style', '');
          }
          
    }).on('hideTab', function(e, tabId){
      
      var el = $(this),
          bodyEl = $('.popup-wrapper__body', el),
          selectedTab = $('.popup-section--'+tabId, el),
          selectedButton = $('[data-tab="'+tabId+'"]', el);
          
          $(selectedTab).removeClass('open');
          $(selectedButton).removeClass('open');
          
          if(!$('.popup-section.open', el).length) {
            $(el).trigger('showIntro');
          }
          
          $(bodyEl).attr('style', '');
      
    }).on('openPopup', function(){
      
      var el          = $(this), 
          popupEl     = $('.popup', el),
          id          = $(popupEl).attr('id'),
          closePopups = $(el).data('close-popups'),
          spriteEl    = $('#'+id+'-sprite');
          
          if(closePopups.length) {
            closePopups.split(',').forEach(function(item, index) { // eslint-disable-line
              $('#'+item+'-popup').trigger('closePopup');
            });
          }
          
      $('.current').removeClass('current');
      $(el).trigger('layoutSubviews').addClass('open').addClass('current');
      $(el).trigger('resetTimer').trigger('resetIntro');
      
      $(spriteEl).addClass('selected');
      
    }).on('closePopup', function(){
      
      var el          = $(this), 
          popupEl     = $('.popup', el),
          bodyEl      = $('.popup-wrapper__body', el),
          id          = $(popupEl).attr('id'),
          spriteEl    = $('#'+id+'-sprite');
          
      $(el).trigger('clearTimer');
          
      $(el).removeClass('open').removeClass('current');
      
      $(spriteEl).addClass('will-disappear');
      
      setTimeout(function() {
        $('.popup-section--video', el).trigger('stopVideo');
        $(spriteEl).removeClass('will-disappear').removeClass('selected');
        $('.open', el).removeClass('open');
        $(bodyEl).attr('style', '');
      }, 500);
      
    }).on('layoutSubviews', function(){
      
      var el = $(this), 
          margin = 30,
          popupEl       = $('.popup', el),
          triangleEl    = $('.triangle', el),
          contentEl     = $('.popup .popup__content', el);
          
          $(contentEl).attr('style', '');
          
      var windowHeight  = $('#app').height(),
          popupHeight = $(contentEl).height() + margin,
          //posX = $(el).position().left, 
          posY = $(el).position().top, 
          offset = 0, 
          offsetX = parseInt($(popupEl).data('x-offset')),
          offsetY = parseInt($(popupEl).data('y-offset'));
        
        if(posY < 0) {
          offset = Math.abs(posY) + margin;
        }
        
        if(popupHeight > windowHeight) {
          popupHeight = windowHeight;
          $(contentEl).css('height', popupHeight);
        }
        
        if((posY + popupHeight) > windowHeight) {
          //offset = -1000;
        }
        
        if((posY + popupHeight + offsetY) > windowHeight) {
          //offset = -((posY + popupHeight) - windowHeight); 
          
          popupHeight = (popupHeight - ((posY + popupHeight + offsetY) - windowHeight)) - margin;
          $(contentEl).css('height', popupHeight);
          
        }
        
        if(offset != 0) {
          offsetY = offsetY+offset;
          //$(popupEl).css('top', offset + 'px');
        }
        
//         $(popupEl).css('top', offsetY + 'px').css('left', offsetX + 'px');
        $(popupEl).css('transform', 'translateX(' + offsetX + 'px) translateY(' + offsetY + 'px)');
        
        if(offsetY < 0) {
          $(triangleEl).css('transform', 'translateY(' + Math.abs(offsetY) + 'px)');
        }
        
/*
        if (typeof scrollViews[$(el).index()] === 'undefined') {
          scrollViews[$(el).index()] = new Swiper($('.swiper-container', el), {
            direction: 'vertical',
            slidesPerView: 'auto',
            freeMode: true,
            scrollbar: {
              el: $('.swiper-scrollbar', el),
              hide: true,
              draggable: false,
            },
            mousewheel: true,
            on: {
              setTranslate: function () {
                if($(el).hasClass('open')) {
                  $(el).trigger('resetTimer', [timeoutDuration, false]);
                }
              },
            },
          });
        } else {
          scrollViews[$(el).index()].update();
          scrollViews[$(el).index()].slideTo(0, 0, false);
        }
*/
                        
    });
    
    
    
    $('.sprite').on('initSprite', function(){
      
      var spriteEl = $(this),
          speed   = $(spriteEl).data('speed'),
          width   = $(spriteEl).data('width'),
          frames  = $(spriteEl).data('frames'), 
          xOffset = 0,
          loop    = 0;
          
          
          if(!$(spriteEl).hasClass('sprite--with-popup')) {
            return;
          }
          
          setInterval(function() {
            
            xOffset = -(width * loop);
            
            $(spriteEl).css('background-position', xOffset+'px 0');

            loop++;
            
            if(loop >= frames) {
              loop = 0;
            }

          }, speed);
      
    });
    
    
    
    $('.popup-section--video').on('initVideo', function(){
      
      var el = $(this), 
          wrapperEl = $(el).closest('.popup-wrapper'), // eslint-disable-line
          videoEl = $('video', el), 
          player = $(videoEl).get(0),
          togglePlayEl = $('.play-video', el);
          
          $(togglePlayEl).click(function(e){
            e.preventDefault();
            
            if(player.paused) {
              $(el).trigger('playVideo');
            } else {
              $(el).trigger('pauseVideo');
            }

          });
          
    }).on('playVideo', function(){
      
      var el = $(this), 
          wrapperEl = $(el).closest('.popup-wrapper'),
          videoEl = $('video', el), 
          length = parseInt($(el).data('length')) * 1000,
          player = $(videoEl).get(0);
      
      $(el).addClass('is-playing');
      player.play();
      
      $(wrapperEl).trigger('resetTimer', length);
      
    }).on('pauseVideo', function(){
      
      var el = $(this), 
          wrapperEl = $(el).closest('.popup-wrapper'),
          videoEl = $('video', el), 
          player = $(videoEl).get(0);
      
      $(el).removeClass('is-playing');
      player.pause();
      
      $(wrapperEl).trigger('resetTimer');
      
    }).on('stopVideo', function(){
      
      var el = $(this), 
          wrapperEl = $(el).closest('.popup-wrapper'), // eslint-disable-line
          videoEl = $('video', el), 
          player = $(videoEl).get(0);
      
      $(el).removeClass('is-playing');
      player.pause();
      player.load();
      player.currentTime = 0;
      
      //$(wrapperEl).trigger('resetTimer');
      
    }).trigger('initVideo');
    
    
    
    $('.popup__header--title-1, .popup__header--title-2').on('fit', function(){
      
      var titleEl = $(this),
          fontSize = $(titleEl).css('font-size');
          
      setTimeout(function() {
        $(titleEl).css('line-height', fontSize);
        //$(popupEl).trigger('layoutSubviews');
      }, 100);
        
    }); //.trigger('initTitles');
    
  },
  finalize() {
    
    
    $('body').on('initBody', function(){
      
      if($(this).hasClass('finished-loading')) {
        return;
      }
      
      $('#spinner').addClass('will-remove');
      
      setTimeout(function() {
      
        $('#spinner').remove();
        
        $('body').addClass('finished-loading');
        
        $('.popup-wrapper').trigger('initPopupWrapper');
        $('.sprite').trigger('initSprite');
        //$('#sprite-66').trigger('initSprite');
        
        fitty('.popup__header--title-1, .popup__header--title-2', {});
        
        fitty.fitAll();
        $('.hotspot-wrapper--with-popup').trigger('layoutSubviews');
      
      }, 500);
      
    });
    
    
    var timeout = null;
    
    timeout = setInterval(function(){
      clearInterval(timeout);
      $('body').trigger('initBody');
    }, 60000);
    
    $('.wait-for-load').waitForImages({
        finished: function() {

          setTimeout(function() {
            $('body').trigger('initBody');
          }, 2000);
          
        },
        each: function() {

        },
        waitForAll: true,
    });
    
    
    
    
/*
    setTimeout(function() {
      $('.popup-wrapper').trigger('initPopupWrapper');
      //$('.sprite').trigger('initSprite');
      $('#sprite-66').trigger('initSprite');
    }, 500);
    
    fitty('.popup__header--title-1, .popup__header--title-2', {});
    
    setTimeout(function() {
      fitty.fitAll();
      $('.hotspot-wrapper--with-popup').trigger('layoutSubviews');
    }, 1000);
*/

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js